const startTable = (/** @type {string | string[]} */ labels) => {
	if (!(Array.isArray(labels))) {
		// eslint-disable-next-line no-param-reassign
		labels = [labels];
	}

	let view = '<table class="table table-striped table-bordered"><thead><tr>';

	for (const item of labels) {
		view += `<th>${ item }</th>`;
	}

	view += '</tr></thead>';
	view += '<tbody>';
	return view;
};

const finishTable = () => '</tbody></table>';

const generic = (/** @type {any} */ data, /** @type {any} */ options) => {
	if (typeof data === 'string') {
		return data;
	}
	const makeRow = (/** @type {any} */ rowData, /** @type {boolean} */ noRow) => {
		let view = noRow ? '' : '<tr>';

		if (typeof rowData === 'string' || typeof rowData === 'number') {
			view += `<td>${ rowData }</td>`;
		}
		else if (rowData === null || rowData === undefined) {
			view += '<td></td>';
		}
		else if (Array.isArray(rowData)) {
			for (const item of rowData) {
				view += makeRow(item);
			}
		}
		else if (typeof rowData === 'object') {
			const labels = Object.keys(rowData);

			view += `<td>${ startTable(labels)}`;
			for (const key of labels) {
				view += makeRow(rowData[key], true);
			}
			view += `${finishTable() }</td>`;
		}

		view += noRow ? '' : '</tr>';
		return view;
	};

	// Create a template
	let view = '';
	let label;
	if (!label && options.component && options.component.label) {
		// eslint-disable-next-line prefer-destructuring
		label = options.component.label;
	}
	else if (!label && options.component && options.component.key) {
		label = options.component.key;
	}
	else {
		label = '';
	}

	view += startTable(label);
	view += makeRow(data);
	view += finishTable();
	return view;
};

// Generate a column for the component.
const columnForComponent = (/** @type {any} */ data, /** @type {any} */ options) => {
	// If no component is given, generate an empty cell.
	if (!options.component) {
		return '<td></td>';
	}

	// Generate a table for each component with one column to display the key/value for each component.
	let view = '<td>';
	view += `<table class="table table-striped table-bordered${ options.tableChild ? ' table-child' : '' }">`;
	view += '<thead><tr>';
	view += `<th>${ options.component.label || '' } (${ options.component.key })</th>`;
	view += '</tr></thead>';
	view += '<tbody>';

	// If the component has a defined tableView, use that, otherwise try and use the raw data as a string.
	const info = Object.prototype.hasOwnProperty.call(options.componentInfo.components, options.component.type)
		? options.componentInfo.components[options.component.type]
		: {};
	if (info.tableView) {
		view += `<td>${
			info.tableView(
				data && options.component.key && (Object.prototype.hasOwnProperty.call(data, options.component.key)
					? data[options.component.key]
					: data),
				options,
			) }</td>`;
	}
	else {
		view += '<td>';
		if (options.component.prefix) {
			view += options.component.prefix;
		}
		view += data && options.component.key && (Object.prototype.hasOwnProperty.call(data, options.component.key)
			? data[options.component.key]
			: '');
		if (options.component.suffix) {
			view += ` ${ options.component.suffix}`;
		}
		view += '</td>';
	}

	view += '</tbody></table>';
	view += '</td>';
	return view;
};

const kformGridUtils = {
	generic,
	columnForComponent,
};

export default kformGridUtils;
